import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ce45e04"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-info fas" }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "gray"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "text-break" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "__header" }
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "app-h5" }
const _hoisted_10 = {
  key: 0,
  class: "d-lg-inline-block ms-lg-2 __date"
}
const _hoisted_11 = { class: "__filter-date" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" ÚLTIMO MES ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" ÚLTIMO TRIMESTRE ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" ÚLTIMO SEMESTRE ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" ÚLTIMO AÑO ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_satelital_image_component = _resolveComponent("satelital-image-component")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_satelital_chart_component = _resolveComponent("satelital-chart-component")!
  const _component_satelital_image_modal_component = _resolveComponent("satelital-image-modal-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      _ctx.satelitalPoint && _ctx.satelitalPoint.samplingPoint && _ctx.satelitalPoint.samplingPoint.samplingPoint
    )
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 0,
          class: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 10 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { lg: 16 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table, {
                      data: _ctx.satelitalPoint.estimations,
                      stripe: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: _ctx.$t('label.name')
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              class: "info",
                              size: "small",
                              circle: "",
                              onClick: ($event: any) => (_ctx.dialogInfoParamOpen(scope.row.parameter))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_1
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_link, {
                              type: "primary",
                              class: "ms-1",
                              onClick: ($event: any) => (_ctx.changeParameterGraph(scope.row.parameter)),
                              disabled: scope.row.parameter === _ctx.parameterGraph
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("enum.params." + scope.row.parameter)), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "disabled"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          prop: "value",
                          label: _ctx.$t('label.value')
                        }, {
                          default: _withCtx((scope) => [
                            (scope.row.value === null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString("No se ha podido analizar. Imagen inválida."), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$n(scope.row.value, "fourDecimals")), 1))
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { lg: 8 }, {
                  default: _withCtx(() => [
                    (_ctx.satelitalPoint)
                      ? (_openBlock(), _createBlock(_component_satelital_image_component, {
                          key: 0,
                          images: [_ctx.satelitalPoint],
                          class: "__image"
                        }, null, 8, ["images"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_dialog, {
              modelValue: _ctx.dialogInfoParamVisible,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogInfoParamVisible) = $event)),
              title: _ctx.$t('enum.params.' + _ctx.dialogInfoParam) + ' (' + _ctx.dialogInfoParam + ') ',
              "destroy-on-close": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("info.param." + _ctx.dialogInfoParam)), 1),
                  _hoisted_5,
                  _createElementVNode("p", null, _toDisplayString("Rango: " + _ctx.$t("label.ranges." + _ctx.dialogInfoParam)), 1),
                  _hoisted_6,
                  _createElementVNode("p", null, _toDisplayString("Unidad de medida: " + _ctx.$t("label.measurement_units." + _ctx.dialogInfoParam)), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "title"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.satelitalPoint && _ctx.parameterGraph !== '')
      ? (_openBlock(), _createBlock(_component_el_card, { key: 1 }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("strong", _hoisted_9, _toDisplayString(_ctx.$t("enum.params." + _ctx.parameterGraph)), 1),
                (_ctx.satelitalPoint.dateTime)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.dateFormatDate(_ctx.startDate)) + " - " + _toDisplayString(_ctx.dateFormatDate(_ctx.endDate)), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { lg: 6 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_el_button, {
                        class: "btn blue",
                        id: "btnMonth",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLastMonth()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        class: "btn",
                        id: "btnTri",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showLastTrimester()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        class: "btn",
                        id: "btnSem",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showLastSemester()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        class: "btn",
                        id: "btnYear",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showLastYear()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { lg: 18 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_satelital_chart_component, {
                      parameterName: _ctx.parameterGraph,
                      dataCollection: _ctx.dataCollection,
                      images: [_ctx.satelitalPoint],
                      satelitalSamplingPointId: _ctx.satelitalSamplingPointId
                    }, null, 8, ["parameterName", "dataCollection", "images", "satelitalSamplingPointId"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_satelital_image_modal_component, {
              visible: _ctx.dialogImageVisible,
              title: _ctx.dialogImageTitle,
              images: _ctx.dialogImage ? [_ctx.dialogImage] : [],
              onClose: _ctx.dialogImageClose
            }, null, 8, ["visible", "title", "images", "onClose"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}